export const coveredCards = {
  child: 'children',
  childOnly: 'child_only',
  spouse: 'spouse',
  stepParents: 'stepParents',
  subscriber: 'subscriber',
};
